import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class CryptoService {
  key = CryptoJS.enc.Utf8.parse('7061737323313233'); //replace with your key
  iv = CryptoJS.enc.Utf8.parse('7061737323313233'); //replace with your IV
  constructor() { }


  Encrypt(value) : string {

    try {
      var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value), this.key,
        {
          keySize: 128 / 8,
          iv: this.iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });

      return encrypted.toString();

    } catch (e) {
      ////console.log(e);
      return '';
    }
  }

  Decrtpt(value):string {

    try {
      var decrypted = CryptoJS.AES.decrypt(value, this.key, {
        keySize: 128 / 8,
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      ////console.log(e);
      return '';
    }
  }
}
